import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from '../Actions';

const mapStatetoProps = state => {

    const { landing } = state;
    return {
        machineID:landing.machineID,
        kitchenId:landing.kitchenId,
        location:landing.location,
    }

};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        setMachineID:Actions.setMachineID,
    },
    dispatch
    )
});

export default connect(mapStatetoProps,mapDispatchToProps);